import { render, staticRenderFns } from "./chipButton.vue?vue&type=template&id=21d6ef4f&scoped=true&"
import script from "./chipButton.vue?vue&type=script&lang=js&"
export * from "./chipButton.vue?vue&type=script&lang=js&"
import style0 from "./chipButton.vue?vue&type=style&index=0&id=21d6ef4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d6ef4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d6ef4f')) {
      api.createRecord('21d6ef4f', component.options)
    } else {
      api.reload('21d6ef4f', component.options)
    }
    module.hot.accept("./chipButton.vue?vue&type=template&id=21d6ef4f&scoped=true&", function () {
      api.rerender('21d6ef4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chipButton/chipButton.vue"
export default component.exports